module.exports = __webpack_public_path__ + "static/media/25-9.74e29561.mp3";